import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { I2gNgTrackingService, ITrackingObject } from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';
import { SetPasswordInvalidTokenBuilder } from './set-password-invalid-token.builder';
import { AccountStore } from '../../store/stores';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AlignmentEnum, IconSizesEnum, IIcon, IRouter } from 'i2g-ng-ui';

@Component({
  selector: 'app-set-password-invalid-token',
  templateUrl: './set-password-invalid-token.component.html',
  styleUrls: ['./set-password-invalid-token.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [SetPasswordInvalidTokenBuilder],
})
export class SetPasswordInvalidTokenComponent implements OnInit, AfterViewInit {
  errorIcon: IIcon;
  trackingScreenName: TrackingScreenNamesEnum;
  trackingObject$: Observable<ITrackingObject>;
  forgotPasswordRoute: IRouter;
  AlignmentEnum: typeof AlignmentEnum;

  constructor(
    private _trackingService: I2gNgTrackingService,
    private _setPasswordInvalidTokenBuilder: SetPasswordInvalidTokenBuilder,
    private _accountStore: AccountStore
  ) {}

  ngOnInit() {
    this.AlignmentEnum = AlignmentEnum;
    this.trackingScreenName = TrackingScreenNamesEnum.set_password_failed;
    this.trackingObject$ = this._accountStore
      .getTrackingObject()
      .pipe(shareReplay(1));
    this.forgotPasswordRoute = this._setPasswordInvalidTokenBuilder.buildForgotPasswordRoute();

    this.errorIcon = {
      name: 'error-reset',
      size: IconSizesEnum.custom,
    };
  }

  ngAfterViewInit() {
    this._trackingService.trackPage(this.trackingScreenName);
  }
}
